import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { MemberAuthProvider } from "@/context/MemberAuthContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Project from "@/pages/Project";
import Membership from "@/pages/Membership";
import Volunteer from "@/pages/Volunteer";
import Support from "@/pages/Support";
import Gallery from "@/pages/Gallery";
import News from "@/pages/News";
import Leadership from "@/pages/Leadership";
import TopicPage from "@/pages/TopicPage";
import OrisaEncyclopedia from "@/pages/OrisaEncyclopedia";
import HistoryTimeline from "@/pages/HistoryTimeline";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import OrisaDetail from "@/pages/OrisaDetail";
import YorubaDictionary from "@/pages/YorubaDictionary";
import Proverbs from "@/pages/Proverbs";
import RoyalTitles from "@/pages/RoyalTitles";
import RoyalTitleDetail from "@/pages/RoyalTitleDetail";
import Courses from "@/pages/Courses";
import CourseSuccess from "@/pages/CourseSuccess";
import Adverts from "@/pages/Adverts";
import NamesDirectory from "@/pages/NamesDirectory";
import Quiz from "@/pages/Quiz";
import DailyQuestion from "@/pages/DailyQuestion";
import Museums from "@/pages/Museums";
import Celebrate from "@/pages/Celebrate";
import Events from "@/pages/Events";
import EventRegisterSuccess from "@/pages/EventRegisterSuccess";
import PayCallback from "@/pages/PayCallback";
import Shop from "@/pages/Shop";
import Cart from "@/pages/Cart";
import ShopSuccess from "@/pages/ShopSuccess";
import Account from "@/pages/Account";
import AuthCallback from "@/pages/AuthCallback";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";
import NotFound from "@/pages/NotFound";

function SiteRoutes() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/project" element={<Project />} />
        <Route path="/membership" element={<Membership />} />
        <Route path="/volunteer" element={<Volunteer />} />
        <Route path="/support" element={<Support />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/news" element={<News />} />
        <Route path="/leadership" element={<Leadership />} />
        <Route path="/topic/:slug" element={<TopicPage />} />
        <Route path="/orisa" element={<OrisaEncyclopedia />} />
        <Route path="/orisa/:slug" element={<OrisaDetail />} />
        <Route path="/dictionary" element={<YorubaDictionary />} />
        <Route path="/proverbs" element={<Proverbs />} />
        <Route path="/royal-titles" element={<RoyalTitles />} />
        <Route path="/royal-titles/:id" element={<RoyalTitleDetail />} />
        <Route path="/names" element={<NamesDirectory />} />
        <Route path="/quiz" element={<Quiz />} />
        <Route path="/daily-question" element={<DailyQuestion />} />
        <Route path="/museums" element={<Museums />} />
        <Route path="/celebrate" element={<Celebrate />} />
        <Route path="/events" element={<Events />} />
        <Route path="/events/register/success" element={<EventRegisterSuccess />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop/cart" element={<Cart />} />
        <Route path="/shop/success" element={<ShopSuccess />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/courses/success" element={<CourseSuccess />} />
        <Route path="/adverts" element={<Adverts />} />
        <Route path="/pay/callback" element={<PayCallback />} />
        <Route path="/account" element={<Account />} />
        <Route path="/timeline" element={<HistoryTimeline />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}

function RootRoutes() {
  const location = useLocation();
  // Detect Emergent OAuth return synchronously (hash fragment) BEFORE any route/auth check.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/*" element={<SiteRoutes />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <MemberAuthProvider>
          <CurrencyProvider>
            <BrowserRouter>
              <RootRoutes />
            </BrowserRouter>
            <Toaster position="top-center" richColors closeButton />
          </CurrencyProvider>
        </MemberAuthProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
